import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import CONSTANTS from '../../constants';

class ErrorHandler extends Component {

  async componentDidMount() {
    // Track an event when the component mounts
    await this.trackEvent('Error Page Shown', { page: 'Main Page' });
  }

  async trackEvent(eventName, eventData) {
    try {
      if (window.clarity && typeof window.clarity.apply === 'function') {
        window.clarity('set', eventName, eventData.page);
      } else {
        console.warn('Clarity object is not defined or has no apply method.');
      }
    } catch (error) {
      console.error('Error integrating Clarity:', error);
    }
  }

  onClear() {
    //this.props.clear();
    window.location.reload();
    //this.props.history.replace(`${CONSTANTS.BASE_URL}${this.props.locationSlug}`);
  }

  render() {
    return (
      <div className="error">
        <div className="intro f0">Error</div>
        <div className="f3 p-3">
          {CONSTANTS.ERRORS[this.props.errorCode] ||
            CONSTANTS.ERRORS.DEFAULT}
        </div>
        <div className="f4 ps-3 text-normal">
          Reason: {this.props.errorMessage}
        </div>
        {this.props.locationSlug && (
          <div className="p-3" onClick={this.onClear.bind(this)}>
            <button className="btn btn-primary">Retry</button>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(ErrorHandler);
